import React from "react";
import { Popover, Button as AntdButton, Icon, Select } from "antd";
import { useTranslation } from "react-i18next";

import Button from "../../../../components/Button";

import { canMoveToStepWarning, getStepDisplayName } from "./selectors";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  width: min-content;

  .content {
    display: flex;
    gap: 12px;
  }

  .select {
    width: 200px;
  }
`;

const Warning = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  font-size: 10px;

  i {
    color: ${({ theme }) => theme["@warning"]};
    margin-right: 12px;
  }
`;

export const MoveToNextStepForm = ({
  disabled,
  steps,
  step,
  matches,
  opportunity,
  onSubmit
}) => {
  const { t } = useTranslation(["opportunity"]);
  const [nextStepIndex, setNextStepIndex] = React.useState(0);
  const nextStep = steps[nextStepIndex];
  const error = canMoveToStepWarning({ step, nextStep, matches, opportunity });

  return (
    <Wrapper data-test="step-popover">
      <div className="content">
        <Select
          data-test="move-candidate-select"
          className="select"
          onChange={setNextStepIndex}
          value={nextStepIndex}
        >
          {steps.map((value, index) => (
            <Select.Option
              // TODO remove this option if we don't use it
              disabled={value.disabled}
              key={index}
              value={index}
            >
              {getStepDisplayName(value, t)}
            </Select.Option>
          ))}
        </Select>
        <Button
          data-test="move-candidate-confirm-btn"
          type="tertiary"
          onClick={() => onSubmit(nextStep.id, nextStep)}
          disabled={disabled || error}
        >
          {t("global:accept")}
        </Button>
      </div>
      {error && (
        <Warning data-test="move-candidate-error">
          <Icon type="warning" />
          {error}
        </Warning>
      )}
    </Wrapper>
  );
};

const StepPopover = ({
  steps,
  step,
  matches,
  opportunity,
  onSubmit,
  children,
  disabled,
  ...props
}) => {
  return (
    <Popover
      disabled={disabled}
      placement="right"
      trigger="click"
      content={
        <MoveToNextStepForm
          disabled={disabled}
          steps={steps}
          step={step}
          matches={matches}
          opportunity={opportunity}
          onSubmit={onSubmit}
        />
      }
    >
      <AntdButton
        type="primary"
        disabled={disabled}
        data-test="move-candidate-trigger-btn"
        {...props}
        style={{ margin: "0 auto" }}
      >
        {children} <Icon style={{ marginLeft: 0 }} type="double-right" />
      </AntdButton>
    </Popover>
  );
};

export default StepPopover;
